
export const EventType = Object.freeze({
  NOTIFICATION_RECEIVE: 'NOTIFICATION_RECEIVE'
})

export class NotificationsEventBusEmiter {
  constructor(eventBus) {
    this.eventBus = eventBus
  }

  callNotificationReceive(payload) {
    this.eventBus.$emit(EventType.NOTIFICATION_RECEIVE, payload)
  }
}